import { useEffect } from 'react';
import { TAG_ID } from '@/consts/tagIds';
import { getPhrases } from '@/utils/getPhrases';
import { useAuthStore } from '@/store/authStore/authStore';
import { usePhrasesStore } from '@/store/phrasesStore';
import { useLocale } from '@/hooks/general/useLocale/useLocale';
import * as Sentry from '@sentry/nextjs';

export const useSubpanelPhrasesUpdate = () => {
    const { locale } = useLocale();
    const { loggedIn, subpanelName } = useAuthStore((state) => ({
        loggedIn: state.loggedIn,
        subpanelName: state.subpanelName,
    }));
    const { setPhrases, clearPhrases } = usePhrasesStore((state) => ({
        setPhrases: state.setPhrases,
        clearPhrases: state.clearPhrases,
    }));

    const phrasesType = 'subpanel';

    useEffect(() => {
        if (loggedIn && subpanelName) {
            void (async () => {
                const phrases = await getPhrases({
                    tagIds: [TAG_ID.SUBPANEL],
                    subpanelName,
                    locale,
                    path: '/',
                });
                setPhrases(phrases, phrasesType).catch((err) =>
                    Sentry.captureException(err, { extra: { phrases, phrasesType } }),
                );
            })();
        } else {
            clearPhrases(phrasesType);
        }
    }, [locale, subpanelName, loggedIn, setPhrases, clearPhrases]);
};
